import { render, staticRenderFns } from "./ToolBarWindow.vue?vue&type=template&id=07a673c9&scoped=true"
import script from "./ToolBarWindow.vue?vue&type=script&lang=js"
export * from "./ToolBarWindow.vue?vue&type=script&lang=js"
import style0 from "./ToolBarWindow.vue?vue&type=style&index=0&id=07a673c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a673c9",
  null
  
)

export default component.exports